import type {UUID} from 'src/typings';
import type {ToastMessageService} from 'shared/components/kp-toast-messages';
import type {WalkerService} from 'shared/services';
import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';
import type {FileService} from 'src/features/file/file.service';
import type {ReportProcessingService} from './report-processing.service';
import type RecordDataService from 'src/features/record/record.data-service';
import type RecordService from 'src/features/record/record.service';
import {exists} from 'shared/utils/custom-utils';

/*@ngInject*/
export function reportProcessingRoutes($stateProvider: StateProvider) {
    let reportProcessingModule: {default: any;};

    if (window.portaroConfiguration.isSutorSutinLayout) {
        $stateProvider
            .state({
                name: 'reports-processing',
                url: '/reports/processing/:id',
                component: KpSvelteComponentWrapperComponent.componentName,
                resolve: {
                    component: () => reportProcessingModule.default,

                    /*@ngInject*/
                    props: async (
                        recordDataService: RecordDataService,
                        reportProcessingService: ReportProcessingService,
                        fileService: FileService,
                        toastMessageService: ToastMessageService,
                        walker: WalkerService,
                        recordService: RecordService,
                        $stateParams: {id: UUID} // Injects URL parameters
                    ) => {
                        try {
                            const record = await recordDataService.getById($stateParams.id);

                            const [recordHoldings, sharableDepartments, totalReported] = await Promise.all([
                                recordService.getAllRecordHoldings(record).then((allHoldings) => allHoldings.filter((holding) => holding?.editPermission?.allowed)),
                                recordService.getAssignableDepartments(),
                                reportProcessingService.getTotalReported(record)
                            ]);

                            if (!exists(record) || !exists(record.directoryId)) {
                                toastMessageService.showError('Neplatný záznam!');
                                await walker.newSpaPage('reports');
                                return {};
                            }

                            const allFiles = await fileService.getFilesByDirectory(record.directoryId);
                            if (allFiles.length === 0) {
                                toastMessageService.showError('Záznam neobsahuje žádný soubor!');
                                await walker.newSpaPage('reports');
                                return {};
                            }

                            return {
                                file: allFiles[0],
                                record,
                                recordHoldings,
                                totalReported,
                                sharableDepartments
                            };
                        } catch (e) {
                            toastMessageService.showError(`Nastala chyba: ${e.message}`);
                            await walker.newSpaPage('reports');
                            return {};
                        }
                    }
                },
                lazyLoad: async () => {
                    reportProcessingModule = await import(/* webpackChunkName: "reportProcessingPage" */ './ReportProcessingPage.svelte');
                    return null;
                }
            });
    }
}